export default "__VITE_ASSET__CF$7mEsc__"